/**
 * TUVI - Ficha FFE dentro del Proyecto
 * Carga la cotizacion vinculada y renderiza FichaFFE completo en modo lectura
 */
import React, { useState, useEffect } from 'react';
import client from '../../../services/graphqlClient';
import FichaFFE from '../../Documentos/FichaFFE';
import RecepcionFfe from './RecepcionFfe';

export default function FichaFfeProyecto({ proyectoId }) {
  const [ffeLink, setFfeLink] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const d = await client.query(`query($pid: Int!) { fichaFfeProyecto(proyecto_id: $pid) { cotizacion_id source } }`, { pid: proyectoId });
        setFfeLink(d.fichaFfeProyecto || null);
      } catch (err) { console.error('Error cargando FFE link:', err); }
      finally { setLoading(false); }
    };
    cargar();
  }, [proyectoId]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Cargando Ficha FFE...</div>;
  if (!ffeLink) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Este proyecto no tiene Ficha FFE asociada</div>;

  return (
    <>
      {/* Aceptación del recibo del material por el residente del proyecto */}
      <RecepcionFfe proyectoId={proyectoId} />
      <FichaFFE embebidoCotId={ffeLink.cotizacion_id} embebidoSource={ffeLink.source} />
    </>
  );
}
